import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetPricingHubAgentRecsDocument = gql`
  query GetPricingHubAgentRecs {
    getPricingHubAgentRecs {
      to_review_count
      weekly_gp_impact_in_micros
    }
  }
`;
export function useGetPricingHubAgentRecsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetPricingHubAgentRecsQuery,
    Types.GetPricingHubAgentRecsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPricingHubAgentRecsQuery,
    Types.GetPricingHubAgentRecsQueryVariables
  >(GetPricingHubAgentRecsDocument, options);
}
export function useGetPricingHubAgentRecsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPricingHubAgentRecsQuery,
    Types.GetPricingHubAgentRecsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPricingHubAgentRecsQuery,
    Types.GetPricingHubAgentRecsQueryVariables
  >(GetPricingHubAgentRecsDocument, options);
}
export type GetPricingHubAgentRecsQueryHookResult = ReturnType<
  typeof useGetPricingHubAgentRecsQuery
>;
export type GetPricingHubAgentRecsLazyQueryHookResult = ReturnType<
  typeof useGetPricingHubAgentRecsLazyQuery
>;
export type GetPricingHubAgentRecsQueryResult = Apollo.QueryResult<
  Types.GetPricingHubAgentRecsQuery,
  Types.GetPricingHubAgentRecsQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetPricingHubAgentRecsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetPricingHubAgentRecsQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetPricingHubAgentRecsQuery,
    Types.GetPricingHubAgentRecsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetPricingHubAgentRecsQuery,
    Types.GetPricingHubAgentRecsQueryVariables
  >(GetPricingHubAgentRecsDocument, options);
}

/**
 * Wrapped version of useGeneratedGetPricingHubAgentRecsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetPricingHubAgentRecsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetPricingHubAgentRecsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetPricingHubAgentRecsQuery,
    Types.GetPricingHubAgentRecsQueryVariables
  >(GetPricingHubAgentRecsDocument, lazyOptions);
}
